import { newsCategories } from '@r1-frontend/api-domru/content-static/v1/news-categories';
import { news as getNews } from '@r1-frontend/api-domru/content-static/v2/news';
import get from 'lodash/get';
import Head from 'next/head';
import { withRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import News from '~/src/components/News';
import Layout from '~/src/features/_layout';
import * as base from '~/src/helpers/basePageFunc';
import getRequester from '~/src/helpers/getRequester';
import { setNewsResponse } from '~/src/store/actions/news';
import { setTagResponse } from '~/src/store/actions/tags';
import { getCurrentCity, selectCompanyName } from '~/src/store/selectors/city';

class NewsPage extends Component {
    static propTypes = {
        currentCity: PropTypes.object,
        companyName: PropTypes.string,
    }

    static defaultProps = {
        currentCity: {},
        companyName: 'Дом.ру',
    }

    static async getInitialProps(options) {
        await base.initialProps(options);

        const { store, query, req } = options;
        const doRequest = getRequester(req);

        const { tags, month, year, page } = query;
        const state = store.getState();

        const { city, news } = state;
        const providerId = get(city, 'provider.providerId');
        const currentCity = getCurrentCity(state);
        const companyName = selectCompanyName(state);

        const [tagsRes, newsRes] = await Promise.all([
            doRequest.apiContentStatic(newsCategories()),
            doRequest.apiContentStatic(
                getNews(providerId, {
                    page,
                    categoryAlias: tags,
                    month,
                    year,
                    sort: '-activeFrom',
                    hideFutureNews: true,
                    withCategoriesInfo: true,
                    hidden: false,
                }),
            ),
        ]);
        const prevItems = news.itemsByAlias;

        store.dispatch(setTagResponse(tagsRes));
        store.dispatch(setNewsResponse({ response: newsRes, prevItems }));

        return { isFirstPage: !page, currentCity, companyName };
    }

    render() {
        const { currentCity, isFirstPage, companyName } = this.props;
        const { cityIn } = currentCity;

        return (
            <>
                <Head>
                    <meta name='robots' content={isFirstPage ? '' : 'noindex, follow'}/>
                </Head>
                <Layout
                    title={`Все новости от провайдера домашнего интернета, телевидения и телефона ${companyName} в ${cityIn}`}
                    description={`Следите за новостями ${companyName}: быстрый Интернет, Цифровое Телевидение HD качества, IP-телефония.`}
                    withMenu={true}
                    withChat={true}
                    withFooter={true}
                >
                    <News />
                </Layout>
            </>
        );
    }
}

export default withRouter(NewsPage);
